// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/between-vertical-start.js';

import { paths } from '../generated/between-vertical-start';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('between-vertical-start', Original, paths);
